<script lang="ts"></script>

<div class="spinner-wrap"><div class="spinner" role="status" aria-label="Loading"></div></div>
